<div class="grid-date" *ngIf="dateValue">
  <span class="icon-calendar"></span>
  <span class="info-date">{{ dateValue }}</span>
</div>